import { generatedAPI } from './endpoints.gen';

export const iamAPI = generatedAPI.enhanceEndpoints({});

export const { useGetDisplayMappingQuery } = generatedAPI;
